import styled from 'styled-components';

import { useContext, useMemo } from 'react';
import { useScreenClass } from 'react-grid-system';

import User from '../types/User';
import FlexBox, { FlexBoxProps, FlexGrow } from './FlexBox';
import Status from '../types/enum/Status';
import Breadcrumb from './Breadcrumb';
import theme from '../styles/theme';
import { UserContext } from '../context/UserContext';

const StyledNavbar = styled(FlexBox)<{ isOpen?: boolean } & FlexBoxProps>`
  background-color: ${theme.color.lightBlueGray200};
  box-shadow: ${({ theme }) => theme.shadow(2, Status.default)};
  z-index: 1000;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 12px;
  position: fixed;
  left: ${({ isOpen }) =>
    isOpen ? theme.sidebarWidth : `calc(${theme.sidebarWidth} - 180px)`};
  top: 10px;
  width: 100%;
`;

export type NavbarProps = {
  breadcrumb: Array<{
    name: string;
    link?: string;
  }>;
  user?: User;
  onSidebarToggle?: (arg0: unknown) => void;
  showSignout?: boolean;
};

function CompetencyNavbar({ breadcrumb }: NavbarProps): JSX.Element {
  const screenClass = useScreenClass();
  const userContext = useContext(UserContext);
  const isMobile = useMemo(
    () => ['xs', 'sm'].includes(screenClass),
    [screenClass],
  );
  return (
    <>
      <StyledNavbar space={5} isOpen={userContext.roadmapView.sidebar}>
        <FlexBox style={{ flexBasis: '100%' }}>
          <FlexGrow>
            <Breadcrumb path={breadcrumb} />
          </FlexGrow>
        </FlexBox>
      </StyledNavbar>
    </>
  );
}

export default CompetencyNavbar;
